/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// // Get all elements with the same class
const remove_buttons = document.querySelectorAll('.qucik-links__links');
const heading_chang = document.querySelector('.collection__title');
 let selected = ['Brand'];
const add = document.querySelector('.add_qucikLink_buttons'); // single element

const seenFilters = new Set();

function readFilters() {
const urlParams = new URLSearchParams(window.location.search);
let filters = {};

urlParams.forEach((value, key) => {
  if (key.startsWith("filter.")) {
    if (!filters[key]) {
      filters[key] = [];
    }

    // only push if not already inside
    if (!filters[key].includes(value)) {
      filters[key].push(value);
    }
  }
});

add.innerHTML = ""; // clear before rendering
Object.keys(filters).forEach(key => {
  filters[key].forEach(value => {
    add.innerHTML += `
      <span class="filter-chip" data-chip="${value}">
        ${value}
        <button class="x" onclick="removeItem('${value}')">×</button>
      </span>`;

  });
  
});

}

// Run on first page load
readFilters();

// Detect URL changes without reload (AJAX filtering)
let lastUrl = location.href;
new MutationObserver(() => {
  const currentUrl = location.href;
  if (currentUrl !== lastUrl) {
    lastUrl = currentUrl;
    readFilters();
  }
}).observe(document, {subtree: true, childList: true});

function window_load_cls() {
  add.innerHTML = ""; // remove all chips
  document.querySelectorAll('.checkbox').forEach(chk => chk.checked = false);
  remove_buttons.forEach(btn => btn.parentElement.classList.remove("active-button"));
    const clearbutton = document.querySelector('.collection__clear-filter');
    clearbutton.dispatchEvent(new Event("click", { bubbles: true }));
    // selected.length = 0;
    selected.splice(0, selected.length);
   heading_chang.textContent = "All products";
}
window.addEventListener("load", window_load_cls);

// document.addEventListener("click", function(e) {
//   if (e.target.matches(".pill")) {
//     myFunction();
//   }
// });
document.getElementById('clear').addEventListener('click', function(e){
 window_load_cls();
});
function openAccount(){ document.getElementById('accountDrawer').classList.add('open'); }
function closeAccount(){ document.getElementById('accountDrawer').classList.remove('open'); }

document.addEventListener("DOMContentLoaded", function() {
  const checkoutBtn = document.getElementById("direct-checkout-btn");
  const form = document.querySelector('form[action*="/cart/add"]');

  if (checkoutBtn && form) {
    checkoutBtn.addEventListener("click", function() {
      // simulate form submit with checkout redirect
      const formData = new FormData(form);

      fetch('/cart/clear.js', { method: 'POST' }) // clear cart first
        .then(() => fetch(form.action, { method: 'POST', body: formData })) // add product
        .then(() => window.location.href = '/checkout'); // redirect to checkout
    });
  }
});

const specsContainer = document.querySelector('.specs');
if (specsContainer) {
  const table = document.createElement('table');
  table.classList.add('product-specs');
  
  document.querySelectorAll('.tcustomizer-data input').forEach(input => {
    const name = input.name.replace('properties[', '').replace(']', '');
    const value = input.value;

    if (value) {
      const row = document.createElement('tr');
      row.innerHTML = `<td><strong>${name}</strong></td><td>${value}</td>`;
      table.appendChild(row);
    }
  });

  specsContainer.appendChild(table);
}

const slider = document.querySelector('.slider-img');
  const slides = document.querySelectorAll('.slide-img');
  const prev = document.querySelector('.prev');
  const next = document.querySelector('.next');

  let currentIndex = 0;

  // Show slides (3 at once desktop, 1 mobile)
  function updateSlider() {
    const slidesPerView = window.innerWidth <= 768 ? 1 : 3;
    const slideWidth = slides[0].clientWidth;
    slider.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
  }

  next.addEventListener('click', () => {
    const slidesPerView = window.innerWidth <= 768 ? 1 : 3;
    if (currentIndex < slides.length - slidesPerView) {
      currentIndex++;
      updateSlider();
    }
  });

  prev.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  window.addEventListener('resize', updateSlider);